import { useTranslation } from "next-i18next";

export default function BusinessContent() {
  const { t } = useTranslation("business");

  return (
    <div className="text-left space-y-4 text-[#262104] text-base md:text-lg leading-relaxed">
      <h3 className="font-bold text-lg">{t("title")}</h3>
      <p>{t("intro")}</p>

      <ul className="list-disc pl-5 space-y-4">
        <li>
          <p className="font-bold">{t("list.branding.title")}</p>
          <p>{t("list.branding.text")}</p>
        </li>
        <li>
          <p className="font-bold">{t("list.custom.title")}</p>
          <p>{t("list.custom.text")}</p>
        </li>
        <li>
          <p className="font-bold">{t("list.process.title")}</p>
          <p>{t("list.process.text")}</p>
        </li>
        <li>
          <p className="font-bold">{t("list.shipping.title")}</p>
          <p>{t("list.shipping.text")}</p>
        </li>
      </ul>

      <div>
        <p className="font-bold">{t("conclusion.title")}</p>
        <p>{t("conclusion.text")}</p>
      </div>
    </div>
  );
}
